import React from 'react'

export default function BlankData({ title, onAddClick }) {
    return(
        <div className="flex flex-col items-center justify-center min-h-[400px] p-8 bg-white rounded-xl border border-dashed border-gray-300">
          <div className="mb-4">
            {/* Empty box illustration */}
            <svg 
              className="w-24 h-24 text-gray-300"
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={1.5}
                d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
              />
            </svg>
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No {title} Added Yet</h3>
          <p className="text-gray-500 text-center mb-6 max-w-sm">
            Start by adding {title.toLowerCase()} to help create a comprehensive job posting that attracts the right candidates.
          </p>
          <button
            onClick={onAddClick}
            className="inline-flex items-center px-4 py-2 rounded-lg bg-orange-500 text-white hover:bg-orange-600 transition-colors"
          >
            <svg 
              className="w-5 h-5 mr-2" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 4v16m8-8H4"
              />
            </svg>
            Add {title}
          </button>
        </div>
        );
}
